import { render, staticRenderFns } from "./ClientGeneralForm.vue?vue&type=template&id=7a2a8cd7"
import script from "./ClientGeneralForm.vue?vue&type=script&lang=ts"
export * from "./ClientGeneralForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports